<template>
    <DefaultHeader />
    <div class="container mt-5">
        <div class="card shadow">
            <div class="card-header bg-primary text-white">
                <h3>Ajouter une nouvelle balise</h3>
            </div>
            <div class="card-body">
                <form @submit.prevent="submitForm">
                    <!-- IMEI et Téléphone -->
                    <div class="row mb-3">
                        <div class="col-md-6">
                            <label for="imei" class="form-label">IMEI</label>
                            <input v-model="form.imei" type="text" class="form-control" id="imei" required
                                inputmode="numeric" placeholder="IMEI ou identifiant" />
                        </div>
                        <div class="col-md-6">
                            <label for="tel" class="form-label">Téléphone</label>
                            <input v-model="form.tel" type="text" class="form-control" id="tel"
                                pattern="^\+?\d{8,15}$" placeholder="Numéro de la carte sim" maxlength="16" />
                        </div>
                    </div>

                    <!-- Nom et Type de balise -->
                    <div class="row mb-3">
                        <div class="col-md-6">
                            <label for="name" class="form-label">Nom</label>
                            <input v-model="form.name" type="text" class="form-control" id="name" required />
                        </div>
                        <div class="col-md-6">
                            <label for="type" class="form-label">Type de balise</label>
                            <v-select v-model="form.baliseType" :options="baliseOptions" label="label"
                                :reduce="b => b.value" placeholder="Sélectionner un type" searchable clearable
                                required />

                            <!-- Infos serveur et port -->
                            <div v-if="form.baliseType" class="text-muted d-flex justify-content-start fst-italic">
                                <div class="mx-2"><strong>Serveur :</strong> {{ ipAddressBaliseManager }}</div>
                                <div class="mx-2"><strong>Port :</strong> {{ portsByBaliseType[form.baliseType] }}</div>
                            </div>
                        </div>
                    </div>

                    <!-- Client -->
                    <div class="row mb-3">
                        <div class="col-md-6">
                            <label for="client" class="form-label">Client</label>
                            <v-select v-model="form.clientId" :options="clients" label="name"
                                :reduce="client => client.id" placeholder="Sélectionner un client" searchable clearable
                                required />
                        </div>
                        <div class="col-md-6">
                            <!-- Colonne vide pour garder l'alignement -->
                            <div style="visibility:hidden;">Placeholder</div>
                        </div>
                    </div>

                    <div class="d-flex justify-content-end">
                        <button type="submit" class="btn btn-success">Ajouter</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <DefaultFooter />
</template>

<script setup>
import { useRouter } from 'vue-router'
import { ref, onMounted, computed } from 'vue'

import DefaultHeader from '@/components/DefaultHeader.vue'
import DefaultFooter from '@/components/DefaultFooter.vue'
import baliseService from '@/services/balise.service.js'
import ClientService from '@/services/client.service.js'

const router = useRouter()

const baliseTypes = {
    TLW2: "GEOTRACK W2",
    PIONEERX100: "GEOTRACK P100",
    FMB920: "GEOTRACK B92",
    FMC920: "GEOTRACK C92",
    FMC130: "GEOTRACK C13",
    FMC250: "FMC250",
    FMC650: "FMC650",
    KNIGHTX100: "GEOTRACK X100",
    FMC800: "GEOBD 2",
    TWIGONE: "TWIG ONE",
    TT10: "TT10",
    TLW212B: "GEO TRAILER",
    LL301: "GEONEO",
    NS10: "NS10",
    NS20: "NS20",
    GL521: "GL521",
};

const portsByBaliseType = {
    TLW2: 25152,
    PIONEERX100: 25150,
    FMB920: 25130,
    FMC920: 25131,
    FMC130: 25132,
    KNIGHTX100: 25151,
    FMC800: 25135,
    TWIGONE: 26000,
    TT10: 25137,
    TLW212B: 25138,
    NS10: "SRTECH",
    NS20: "SRTECH"
}

const ipAddressBaliseManager = "tcp.argos-geoloc.com"

const baliseOptions = computed(() =>
    Object.entries(baliseTypes).map(([value, label]) => ({ value, label }))
)

const form = ref({
    imei: '',
    tel: '',
    baliseType: '',
    icon: 'sport-gray.png',
    clientId: '',
    name: '',
    latitude: 49.018528, // Siège de SMS par défaut
    longitude: 2.460264
})

const clients = ref([])

onMounted(async () => {
    try {
        const response = await ClientService.getClients()
        clients.value = response.data
    } catch (error) {
        console.error("Erreur lors du chargement des clients :", error)
    }
})

const submitForm = async () => {
    try {
        const baliseData = { ...form.value }
        const response = await baliseService.createBalise(baliseData)

        alert("Balise créée avec succès !")
        const newBaliseId = response.data.balise.id
        router.push(`/balise/admin/editbalise/${newBaliseId}`)
    } catch (error) {
        console.error("Erreur lors de la création de la balise :", error)
        alert("Une erreur est survenue lors de la création de la balise : " + (error.response?.data?.error || error.message))
    }
}
</script>

<style scoped>
.card {
    border-radius: 1rem;
}

.card-header {
    border-bottom: none;
}

#client {
    max-height: 250px;
    overflow-y: auto;
}
</style>
